import { iriToUuid, toIri } from "@/services/helper"

class BaseTransformer {
  static receiveCollection(items) {
    return items.map(((item) => this.fetch(item)).bind(this))
  }

  static receivePagination(data) {
    return {
      items: data["hydra:member"].map(((item) => this.fetch(item)).bind(this)),
      totalItems: data["hydra:totalItems"]
    }
  }

  static error(error) {
    return error
      ? {
          status: error?.status,
          title: error["data"]["hydra:title"],
          description: error["data"]["hydra:description"],
          violations: error["data"]["violations"] || []
        }
      : null
  }

  static transformUuid(item) {
    return item.uuid ?? iriToUuid(item["@id"])
  }

  static uuidToIri(baseUri, uuid) {
    return toIri(baseUri, uuid)
  }

  static removeEmptyProps(item) {
    let newItem = {}
    Object.keys(item).forEach((key) => {
      if (item[key] != undefined) newItem[key] = item[key]
    })

    return newItem
  }
}

export default BaseTransformer
